/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import theme from '../../theme/theme';
import styles from './styles';

const {
  Icons: { general },
} = theme;
const favoritesScreen = () => ['/favorites'].includes(window.location.pathname);
const recentsScreen = () => ['/recents'].includes(window.location.pathname);

class NoFavoritesRecent extends React.PureComponent {
  showNoFavRecents = () => {
    const { editList, list, t, classes } = this.props;
    const buildIcon = (icon, translation) => (
      <span className={classes.content__wrapper}>
        <img src={icon} className={classes.icon__image} alt="" />
        <Typography className={classes.content__subtitle}>{t(translation)}</Typography>
      </span>
    );
    let noFavRecent = null;
    if (favoritesScreen() && !editList && list.length === 0) {
      noFavRecent = buildIcon(`${general.FavoritesEmptyGray}`, 'favorites.label.no-favorites');
    } else if (recentsScreen() && !editList && list.length === 0) {
      noFavRecent = buildIcon(`${general.RecentLightGray}`, 'recent.label.no-recents');
    }
    return noFavRecent;
  };

  showDeletedFavRecents = () => {
    const { editList, list, t, classes } = this.props;
    const buildIcon = (icon, translation) => (
      <span className={classes.content__wrapper}>
        <img src={icon} className={classes.icon__image} alt="" />
        <Typography className={classes.content__subtitle}>{t(translation)}</Typography>
      </span>
    );
    let deletedFavRecent = null;
    if (favoritesScreen() && editList && list.length === 0) {
      deletedFavRecent = buildIcon(general.FavoritesEmptyGray, 'favorites.label.delete-favorites');
    } else if (recentsScreen() && editList && list.length === 0) {
      deletedFavRecent = buildIcon(general.RecentLightGray, 'recent.label.delete-recents');
    }
    return deletedFavRecent;
  };

  render() {
    return (
      <React.Fragment>
        {this.showNoFavRecents()}
        {this.showDeletedFavRecents()}
      </React.Fragment>
    );
  }
}

NoFavoritesRecent.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  editList: PropTypes.bool.isRequired,
  list: PropTypes.array.isRequired,
};

const mapStateToProps = ({ poi }) => ({
  editList: poi.edit_list_inprogress,
  list: poi.favorite_recent_list,
});

const mapDispatchToProps = () => ({});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(NoFavoritesRecent)),
);
